import React from 'react'
import EmptyGraph from './EmptyGraph'
import EmptyTableImage from 'images/playbook-report/no_results.svg'
import { CHART_NO_DATA_TEXT } from 'constants/ReportConstants'

export const EmptyGraphAndPage = () => (
  <EmptyGraph />
) 

export const EmptyTable = () => (
  <img src={EmptyTableImage} alt={CHART_NO_DATA_TEXT} />
)